import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import Fetch from '../functions/Fetch';
import config from '../../../../config/config';
import ReactTooltip from "react-tooltip";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileLines, faFileContract, faSitemap, faUsers, faNewspaper,
  faCoins, faClipboardCheck, faSquarePollVertical, faBriefcaseMedical,
  faAdjust, faTextHeight
} from '@fortawesome/free-solid-svg-icons';

import './Home.css';

import Contractualization from '../contractualizations/Contractualization'
import Documentation from '../documentations/Documentation'
import Organization from '../organizations/Organization';
import Demonstrative from '../demonstratives/Demonstrative';
import MedicalScale from '../medicalscales/MedicalScale';
import ContractAndEdital from '../contractsandeditals/ContractAndEdital';
import Movement from '../movements/Movement';
import NotFound from '../notfound/NotFound';

const Home = () => {
  const { page, friendly_url } = useParams();

  const [loading, setLoading] = useState(true);
  const [customPortal, setCustomPortal] = useState({});
  const [content, setContent] = useState(page);
  const [highContrastMode, setHighContrastMode] = useState(false);
  const [fontSizeMultiplier, setFontSizeMultiplier] = useState(1);

  useEffect(() => {
    const loadData = async () => {
      let customData;
      if (friendly_url) {
        customData = await Fetch.post(`${config.endpoints.backend}portal/getcustomizations`, { friendly_url });
        if (customData.length > 0) {
          customData = customData[0];
          customData.logo = config.endpoints.backend + customData.logo;
          customData.background_image = config.endpoints.backend + customData.background_image;
          setCustomPortal(customData);
          setLoading(false);
        }
      }
    };

    loadData();
  }, []);

  const toggleHighContrastMode = () => {
    setHighContrastMode(!highContrastMode);
  };

  // Função para aumentar o tamanho da fonte
  const increaseFontSize = () => {
    if (fontSizeMultiplier < 2) {
      setFontSizeMultiplier(fontSizeMultiplier + 0.25);
    } else {
      setFontSizeMultiplier(1)
    }
  };

  const contentStyles = {
    fontSize: `${fontSizeMultiplier}em`,
  };

  if (highContrastMode) {
    contentStyles.filter = 'invert(1) grayscale(1)';
  }

  const handleNavigation = (page) => {
    window.location = `${page}`;
    // setContent(page);
  };

  const renderContent = () => {
    switch (content) {
      case 'home':
        return (
          <div className="portal-content-inner">
            <h2>{customPortal.project_name}</h2>
            <p>{customPortal.description}</p>
            <div className="portal-icons-container">
              <div onClick={() => handleNavigation('documentations')} className="portal-icon-container">
                <FontAwesomeIcon className="portal-icon" icon={faFileLines} />
                <div className="portal-icon-text">Documentação</div>
              </div>
              <div onClick={() => handleNavigation('contractualizations')} className="portal-icon-container">
                <FontAwesomeIcon className="portal-icon" icon={faFileContract} />
                <div className="portal-icon-text">Contratualização</div>
              </div>
              <div onClick={() => handleNavigation('organizations')} className="portal-icon-container">
                <FontAwesomeIcon className="portal-icon" icon={faSitemap} />
                <div className="portal-icon-text">Organização</div>
              </div>
              <div onClick={() => handleNavigation('notfound')} className="portal-icon-container">
                <FontAwesomeIcon className="portal-icon" icon={faUsers} />
                <div className="portal-icon-text">Recursos Humanos</div>
              </div>
              <div onClick={() => handleNavigation('demonstratives')} className="portal-icon-container">
                <FontAwesomeIcon className="portal-icon" icon={faNewspaper} />
                <div className="portal-icon-text">Demonstrativos</div>
              </div>
              <div onClick={() => handleNavigation('notfound')} className="portal-icon-container">
                <FontAwesomeIcon className="portal-icon" icon={faCoins} />
                <div className="portal-icon-text">Finanças</div>
              </div>
              <div onClick={() => handleNavigation('contractsandeditals')} className="portal-icon-container">
                <FontAwesomeIcon className="portal-icon" icon={faClipboardCheck} />
                <div className="portal-icon-text">Editais e Contratos</div>
              </div>
              <div onClick={() => handleNavigation('notfound')} className="portal-icon-container">
                <FontAwesomeIcon className="portal-icon" icon={faSquarePollVertical} />
                <div className="portal-icon-text">Indicadores</div>
              </div>
              <div onClick={() => handleNavigation('medicalscales')} className="portal-icon-container">
                <FontAwesomeIcon className="portal-icon" icon={faBriefcaseMedical} />
                <div className="portal-icon-text">Escala Médica</div>
              </div>
            </div>
          </div>
        );
      case 'documentations':
        return <Documentation />;
      case 'contractualizations':
        return <Contractualization />;
      case 'organizations':
        return <Organization />;
      case 'demonstratives':
        return <Demonstrative />;
      case 'medicalscales':
        return <MedicalScale />;
      case 'contractsandeditals':
        return <ContractAndEdital />;
      case 'notfound':
        return <NotFound />;
      case 'movements':
        return <Movement />;
      default:
        return <NotFound />;
    }
  };

  return (
    !loading && (
      <>
        <div className="portal-home-container" style={contentStyles}>
          <header className="portal-navbar">
            <div className="portal-logo c-pointer" onClick={() => handleNavigation('home')}>
              <img style={{ width: '200px' }} src={customPortal.logo} alt="uploaded" />
            </div>
            <div className="portal-title-subtitle">
              <h1 style={{ color: customPortal.primary_color }}>
                <b>Plataforma de Transparência</b>
              </h1>
              <h2 style={{ color: customPortal.secondary_color }}>
                {customPortal.entity_name}
              </h2>
            </div>
          </header>
          <section
            className="portal-content"
            style={
              content === 'home'
                ? {
                  backgroundImage: `url(${customPortal.background_image})`,
                  color: customPortal.content_color,
                }
                : {
                  paddingTop: '0',
                  textAlign: 'left',
                }
            }>
            {renderContent()}
          </section>
        </div>
        <div className="accessibility-buttons">
          <button className="accessibility-button" onClick={toggleHighContrastMode} data-tip data-for="high-contrast-tooltip">
            <FontAwesomeIcon icon={faAdjust} />
          </button>
          <ReactTooltip id="high-contrast-tooltip" place="right" effect="solid">
            Alto Contraste
          </ReactTooltip>
          <button className="accessibility-button" onClick={increaseFontSize} data-tip data-for="font-size-tooltip">
            <FontAwesomeIcon icon={faTextHeight} />
          </button>
          <ReactTooltip id="font-size-tooltip" place="right" effect="solid">
            Tamanho de fonte
          </ReactTooltip>
        </div>
      </>
    )
  );
};

export default Home;
